import React, { useState } from 'react';
import './navbar.css';
import logo from '../../assets/logo/luxorystudioslogo.jpeg';

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [modelsOpen, setModelsOpen] = useState(false);
  const [photoshootOpen, setPhotoshootOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setMobileMenuOpen(false);
    setModelsOpen(false);
    setPhotoshootOpen(false);
  };

  return (
    <nav className="lx-nav fixed-top">
      <div className="lx-container">
        {/* Brand / Logo */}
        <a href="/" className="lx-brand" onClick={closeMenu}>
          <img src={logo} alt="Luxury Studios" className="lx-logo" />
        </a>

        {/* Desktop Navigation Links */}
        <div className="lx-menu-desktop">
          <ul className="lx-nav-list">
            <li className="lx-nav-item">
              <a className="lx-nav-link active" href="/">Home</a>
            </li>

            {/* Desktop Models Dropdown */}
            <li className="lx-nav-item lx-dropdown">
              <span className="lx-nav-link">
                Models <span className="lx-arrow">▾</span>
              </span>
              <ul className="lx-dropdown-menu">
                <li><a className="lx-dropdown-item" href="/female-models">Female</a></li>
                <li><a className="lx-dropdown-item" href="/male-models">Male</a></li>
                <li><a className="lx-dropdown-item" href="/childfemale-models">Child Female</a></li>
                <li><a className="lx-dropdown-item" href="/childmale-models">Child Male</a></li>
              </ul>
            </li>

            {/* Desktop Photoshoot Dropdown */}
            <li className="lx-nav-item lx-dropdown">
              <span className="lx-nav-link">
                Photoshoot <span className="lx-arrow">▾</span>
              </span>
              <ul className="lx-dropdown-menu">
                <li><a className="lx-dropdown-item" href="/fashion-photos">Fashion Photos</a></li>
                <li><a className="lx-dropdown-item" href="/model-photos">Modeling Photos</a></li>
                <li><a className="lx-dropdown-item" href="#modeling">Portfolio</a></li>
              </ul>
            </li>

            <li className="lx-nav-item">
              <a className="lx-nav-link" href="/contactus">Contact Us</a>
            </li>
          </ul>
        </div>

        {/* Desktop Search */}
        <div className="lx-actions-desktop">
          <div className={`lx-search-box ${searchOpen ? 'open' : ''}`}>
            <input
              type="text"
              placeholder="Search talent..."
              className="lx-search-input"
              onFocus={() => setSearchOpen(true)}
              onBlur={(e) => {
                if (!e.target.value) setSearchOpen(false);
              }}
            />
            <button type="button" className="lx-search-btn" aria-label="Search">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Hamburger Button */}
        <button
          type="button"
          className={`lx-hamburger ${mobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation"
        >
          <span className="lx-bar"></span>
          <span className="lx-bar"></span>
          <span className="lx-bar"></span>
        </button>
      </div>

      {/* Mobile Menu Panel */}
      <div className={`lx-mobile-menu ${mobileMenuOpen ? 'show' : ''}`}>
        {/* Mobile Search Box */}
        <div className="lx-mobile-search">
          <input
            type="text"
            placeholder="Search talent, categories..."
            className="lx-mobile-input"
          />
          <button type="button" className="lx-search-btn" aria-label="Search">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </button>
        </div>

        {/* Mobile Navigation List */}
        <ul className="lx-mobile-list">
          <li className="lx-mobile-item">
            <a href="/" className="lx-mobile-link active" onClick={closeMenu}>Home</a>
          </li>

          {/* Mobile Models Accordion */}
          <li className="lx-mobile-item">
            <button
              type="button"
              className="lx-mobile-accordion-btn"
              onClick={() => setModelsOpen(!modelsOpen)}
            >
              <span>Models</span>
              <span className={`lx-acc-arrow ${modelsOpen ? 'open' : ''}`}>▾</span>
            </button>
            <div className={`lx-mobile-submenu ${modelsOpen ? 'expanded' : ''}`}>
              <a href="/female-models" onClick={closeMenu}>Female</a>
              <a href="/male-models" onClick={closeMenu}>Male</a>
              <a href="/childfemale-models" onClick={closeMenu}>Child Female</a>
              <a href="/childmale-models" onClick={closeMenu}>Child Male</a>
            </div>
          </li>

          {/* Mobile Photoshoot Accordion */}
          <li className="lx-mobile-item">
            <button
              type="button"
              className="lx-mobile-accordion-btn"
              onClick={() => setPhotoshootOpen(!photoshootOpen)}
            >
              <span>Photoshoot</span>
              <span className={`lx-acc-arrow ${photoshootOpen ? 'open' : ''}`}>▾</span>
            </button>
            <div className={`lx-mobile-submenu ${photoshootOpen ? 'expanded' : ''}`}>
              <a href="/fashion-photos" onClick={closeMenu}>Fashion Photos</a>
              <a href="/model-photos" onClick={closeMenu}>Modeling Photos</a>
              <a href="#modeling" onClick={closeMenu}>Portfolio</a>
            </div>
          </li>

          <li className="lx-mobile-item">
            <a href="/contactus" className="lx-mobile-link" onClick={closeMenu}>Contact Us</a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;